const $inject = ['$rootScope', '$filter', 'moment'];

const lbDateSelectCtrl = function ($rootScope, $filter, moment) {
  let vm = this;

  const DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');
  const DISPLAY_DATE_FORMAT = 'ddd Do MMM, YYYY';

  vm.inputName = `${vm.name}.${vm.index}`;

  vm.openDatePicker = openDatePicker;

  function openDatePicker($event) {
    let settings = {
      input: $event.currentTarget,
      parent: 'dateSelect',
      defaultDate: moment(vm.date, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER),
      callBack: dateCallBack
    };

    if(vm.min) {
      settings.minDate = moment(vm.min, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
    }

    if(vm.max) {
      settings.maxDate = moment(vm.max, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
    }

    if(vm.rangeFrom) {
      settings.rangeFrom = moment(vm.rangeFrom, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
    }

    if(vm.rangeTo) {
      settings.rangeTo = moment(vm.rangeTo, DISPLAY_DATE_FORMAT).format(DATE_FORMAT_UPPER);
    }

    // TODO use service instead of events
    $rootScope.$broadcast('openDatePicker', settings);
  }

  function dateCallBack(selection) {
    if(selection) {
      const selectedDate = moment(selection.date);
      vm.date = selectedDate.format(DISPLAY_DATE_FORMAT);
    }

    $rootScope.$broadcast('closeDatePicker');
  }
};

lbDateSelectCtrl.$inject = $inject;

export default lbDateSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbDateSelect/lbDateSelectCtrl.js